export default {
    URL_TOKEN: '/Token',
    URL_PERFIL: '/Cuenta/perfil',
    URL_MODULOS: '/Cuenta/modulos',
}